// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

export const SELECTED_ITEM = '@menu/SELECTED_ITEM';
export const OPEN_DRAWER = '@menu/OPEN_DRAWER';
export const SELECTED_COLLAPSE = '@menu/SELECTED_COLLAPSE';
export const DEFAULT_PERMISSION = '@menu/DEFAULT_PERMISSION';
export const MENU_LIST = '@menu/MENU_LIST';

// action - Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// action - Snackbar
export const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN';
